$("#withconfidenceinsure").hide();
    $("#insurancelogo").hide();
    $("#normallogo").show();
    $("#withconfidencenormal").show();
    $(".insurancehide").show();
    $(".insuranceshow").hide();
    setTimeout(
      function () {
        if (sessionStorage.getItem("isinsurance")) {
          console.log("isinsurance");
          $("#insurancelogo").show();
          $("#normallogo").hide();
          $("#nav-mainmenu").hide();
          $("#loginicon").hide();
          $("#withconfidencenormal").hide();
          $("#withconfidenceinsure").show();
          $('body').addClass("isinsurance");
          $(".insurancehide").hide();
          $(".insuranceshow").show();

        }
      }, 100);